import React from "react";
import styled from "@emotion/styled";
import TitleNavigateButton from "@components/button/TitleNavigateButton";
import SwiperContainer from "@components/swiper/SwiperContainer";
import { useTranslation } from "react-i18next";

const Container = styled.div(
  () =>
    ({
      display: "flex",
      flexDirection: "column",
      gap: "1.6rem",
    }) as const,
);
interface ITitleWrapper {
  align?: string;
}
const TitleWrapper = styled.div<ITitleWrapper>(({ align }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: align ? align : "flex-end",
}));

interface ITitle {
  fontWeight?: number;
}
const Title = styled.h3<ITitle>(({ theme, fontWeight }) => ({
  color: theme.color.black,
  fontSize: "2rem",
  fontWeight: fontWeight ? fontWeight : 600,
  margin: 0,
  lineHeight: "2rem",
}));

type Props = {
  children: React.ReactNode;
  title: string;
  route?: string;
  fontWeight?: number;
  align?: string;
  preview?: number | "auto";
  space?: number;
};
const TitleWithSwiper = ({
  children,
  title,
  route,
  fontWeight,
  align,
  preview = 2,
  space = 8,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Container>
      <TitleWrapper align={align}>
        <Title fontWeight={fontWeight}>{t(title)}</Title>

        {route && <TitleNavigateButton title="전체보기" route={route} />}
      </TitleWrapper>

      <SwiperContainer perView={preview} space={space}>
        {children}
      </SwiperContainer>
    </Container>
  );
};

export default TitleWithSwiper;
